var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrategy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.961,66.703l3.313-3.313c0.781-0.781,0.781-2.047,0-2.828s-2.047-0.781-2.828,0l-3.313,3.313l-3.313-3.313 c-0.781-0.781-2.047-0.781-2.828,0s-0.781,2.047,0,2.828l3.313,3.313l-3.313,3.313c-0.781,0.781-0.781,2.047,0,2.828 c0.391,0.391,0.902,0.586,1.414,0.586s1.023-0.195,1.414-0.586l3.313-3.313l3.313,3.313c0.391,0.391,0.902,0.586,1.414,0.586 s1.023-0.195,1.414-0.586c0.781-0.781,0.781-2.047,0-2.828L64.961,66.703z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.858,48.091l3.313-3.313l3.313,3.313c0.39,0.391,0.902,0.586,1.414,0.586s1.024-0.195,1.414-0.586 c0.781-0.781,0.781-2.047,0-2.828l-3.313-3.313l3.313-3.313c0.781-0.781,0.781-2.047,0-2.828c-0.781-0.781-2.048-0.781-2.828,0 l-3.313,3.313l-3.313-3.313c-0.78-0.781-2.048-0.781-2.828,0c-0.781,0.781-0.781,2.047,0,2.828l3.313,3.313l-3.313,3.313 c-0.781,0.781-0.781,2.047,0,2.828c0.391,0.391,0.902,0.586,1.414,0.586S30.468,48.482,30.858,48.091z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.569,37.085c3.988,0,7.232-3.245,7.232-7.232s-3.244-7.232-7.232-7.232s-7.232,3.245-7.232,7.232 S53.581,37.085,57.569,37.085z M57.569,26.62c1.782,0,3.232,1.45,3.232,3.232s-1.45,3.232-3.232,3.232s-3.232-1.45-3.232-3.232 S55.787,26.62,57.569,26.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.569,40.807c-1.104,0-2,0.896-2,2c0,6.375-5.187,11.562-11.562,11.562c-8.581,0-15.562,6.98-15.562,15.562 c0,1.104,0.896,2,2,2s2-0.896,2-2c0-6.375,5.187-11.562,11.562-11.562c8.581,0,15.562-6.981,15.562-15.562 C59.569,41.703,58.674,40.807,57.569,40.807z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategy);
export default __webpack_public_path__ + "static/media/strategy.d73572b05668e6e2b52b0bc9bc069749.svg";
export { ForwardRef as ReactComponent };